import React, { useState } from "react";

type BigBoxButtonProps = {
  imageSrc: string;
  text: string;
  handleClick: () => void;
  isActive: boolean;
  subtext: string;
};

const BigBoxButton: React.FC<BigBoxButtonProps> = ({
  imageSrc,
  text,
  handleClick,
  isActive,
  subtext,
}) => {
  const [isHovered, setIsHovered] = useState(false);

  const notHovered = () => {
    setIsHovered(false);
  };

  const hovered = () => {
    setIsHovered(true);
  };

  return (
    <button
      className={`flex flex-col items-center justify-center rounded-md p-8 text-white transition-colors duration-300 lg:p-12 xl:p-16 ${
        isActive ? "industry-box-selected" : "industry-box"
      }`}
      onClick={handleClick}
      onMouseEnter={hovered}
      onMouseLeave={notHovered}
    >
      <img
        src={imageSrc}
        alt={text}
        className={`mb-2 h-24 w-24 lg:h-36 lg:w-36 xl:h-48 xl:w-48 ${
          isActive || isHovered ? "industry-img-selected" : "industry-img"
        }`}
      />
      <span className="text-2xl font-bold">{text}</span>
      <span className="text-lg font-bold">{subtext}</span>
    </button>
  );
};

export default BigBoxButton;
